// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.body__no-scroll {
  position: fixed;
  overflow-y: scroll;
  width: 100%;
}

.body--scroll {
  position: static;
  overflow: auto;
}

.modal-backdrop-opacity-override {
  opacity: 1 !important;
  background-color: rgba(0, 0, 0, 0.7);
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/Modal/Modal.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,gBAAA;EACA,cAAA;AACJ;;AAEA;EACI,qBAAA;EACA,oCAAA;AACJ","sourcesContent":[".body__no-scroll {\n    position: fixed;\n    overflow-y: scroll;\n    width: 100%;\n}\n\n.body--scroll {\n    position: static;\n    overflow: auto;\n}\n\n.modal-backdrop-opacity-override {\n    opacity: 1 !important;\n    background-color: rgba(0, 0, 0, 0.7);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
